import { ENV } from '../config/env';
import { http } from '../api/http';

const getToken = () => localStorage.getItem('auth_token');

const parseUploadError = async (res: Response, fallback: string) => {
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    const payload = await res.json().catch(() => null);
    const message = payload?.message || payload?.details?.message;
    if (Array.isArray(message)) return message.join(', ');
    if (typeof message === 'string' && message.trim()) return message;
  }

  const text = await res.text().catch(() => '');
  return text || fallback;
};

export type DeveloperDocumentType = {
  id: string;
  code: string;
  label: string;
};

export type DeveloperDocumentVersion = {
  id: string;
  version: number;
  file_url: string;
  file_name: string;
  file_size: number;
  mime_type: string;
  uploaded_at: string;
};

export type DeveloperProjectDocument = {
  id: string;
  type: DeveloperDocumentType;
  status: string;
  versions?: DeveloperDocumentVersion[];
};

export const DeveloperDocumentsService = {
  listTypes() {
    return http<DeveloperDocumentType[]>('/developer/document-types');
  },

  listDocuments(projectId: number | string) {
    return http<DeveloperProjectDocument[]>(`/developer/projects/${projectId}/documents`);
  },

  async uploadDocument(projectId: number | string, typeId: string, file: File, customLabel?: string) {
    const url = `${ENV.API_URL}/developer/projects/${projectId}/documents/upload`;
    const token = getToken();
    const form = new FormData();
    form.append('typeId', typeId);
    if (customLabel) form.append('customLabel', customLabel);
    form.append('file', file);

    const res = await fetch(url, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: form
    });
    if (!res.ok) {
      throw new Error(await parseUploadError(res, 'Error subiendo documento'));
    }
    return res.json();
  },

  async uploadNewVersion(projectId: number | string, docId: number | string, file: File) {
    const url = `${ENV.API_URL}/developer/projects/${projectId}/documents/${docId}/upload`;
    const token = getToken();
    const form = new FormData();
    form.append('file', file);

    const res = await fetch(url, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: form
    });
    if (!res.ok) {
      throw new Error(await parseUploadError(res, 'Error subiendo versión'));
    }
    return res.json();
  }
};
